module.exports = __webpack_public_path__ + "img/18.2cbae05e.png";